export const ugCollegePoliciesNodes = [
  {
    value: "ii-ug-college-policies",
    label: "II. Policies for the Undergraduate College",
    className: "ii-ug-college-policies",
    children: [
      {
        value: "ii-ug-college-policies/commun-policies",
        label: "A. Policies for the College Community",
        className: "commun-policies",
        children: [
          {
            value: "ii-ug-college-policies/commun-policies/cbrt",
            label: "A.1. Community Bias Response Team Policy",
            className: "cbrt",
          },
          {
            value: "ii-ug-college-policies/commun-policies/comm-council",
            label: "A.2. Community Council",
            className: "comm-council",
          },
          {
            value: "ii-ug-college-policies/commun-policies/empl-conduct",
            label: "A.3. Code of Conduct for Employees",
            className: "empl-conduct",
          },
          {
            value: "ii-ug-college-policies/commun-policies/department-sacs",
            label: "A.4. Departmental Student Advisory Councils",
            className: "department-sacs",
          },
          {
            value: "ii-ug-college-policies/commun-policies/mcsc-constitution",
            label: "A.5. Middlebury Staff Council (MSC) Constitution",
            className: "mcsc-constitution",
          },
          {
            value: "ii-ug-college-policies/commun-policies/pets",
            label: "A.6. Pet Policy",
            className: "pets",
          },
          {
            value:
              "ii-ug-college-policies/commun-policies/reimbursable-moving-exp",
            label: "A.7. Reimbursable Moving Expenditures",
            className: "reimbursable-moving-exp",
          },
          {
            value:
              "ii-ug-college-policies/commun-policies/a-8-committee-on-art-in-public-places",
            label: "A.8. Committee on Art in Public Places",
            className: "a-8-committee-on-art-in-public-places",
          },
        ],
      },
      {
        value: "ii-ug-college-policies/ug-policies",
        label: "B. Policies for Undergraduate College Students",
        className: "ug-policies",
        children: [
          {
            value: "ii-ug-college-policies/ug-policies/academics",
            label: "B.1. Academic Policies",
            className: "academics",
            children: [
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/acad-honesty",
                label:
                  "B.1.a. Academic Honesty, the Honor Code and Related Disciplinary Policies",
                className: "acad-honesty",
              },
              {
                value: "ii-ug-college-policies/ug-policies/academics/calendar",
                label: "B.1.b. Calendar",
                className: "calendar",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/degree-requires",
                label: "B.1.c. Degree Requirements",
                className: "degree-requires",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/satis-acad-prog",
                label: "B.1.d. Satisfactory Academic Progress",
                className: "satis-acad-prog",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/deg-prgms-proj",
                label: "B.1.e. Degree Programs & Projects",
                className: "deg-prgms-proj",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/course-reg-course-conduct",
                label: "B.1.f. Course Registration and Conduct of Courses",
                className: "course-reg-course-conduct",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/summer-study",
                label: "B.1.g. Summer Study",
                className: "summer-study",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/winter-term",
                label: "B.1.h. Winter Term",
                className: "winter-term",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/x-courses-ocs",
                label: "B.1.i. Transfer Courses and Off-campus Study",
                className: "x-courses-ocs",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/eval-student-work",
                label: "B.1.j. Evaluation of Student Work",
                className: "eval-student-work",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/grades-transcripts",
                label: "B.1.k. Grades and Transcripts",
                className: "grades-transcripts",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/student-status",
                label: "B.1.l. Student Status",
                className: "student-status",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/academics/tutor-acad-support",
                label: "B.1.m. Tutoring and Academic Support",
                className: "tutor-acad-support",
              },
            ],
          },
          {
            value:
              "ii-ug-college-policies/ug-policies/res-life-conduct-policies",
            label:
              "B.2. Policies Governing Student Conduct, Residential Life, and Student Organizations",
            className: "res-life-conduct-policies",
            children: [
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/a-introductory-matters",
                label: "B.2.a. Introductory Matters",
                className: "a-introductory-matters",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/genl-cond-standards",
                label: "B.2.b. General Conduct Standards",
                className: "genl-cond-standards",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/hazing-policy",
                label: "B.2.c. Middlebury's Policy Against Hazing",
                className: "hazing-policy",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/general-disciplinary-process",
                label: "B.2.d. Student Conduct Process",
                className: "general-disciplinary-process",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/b-2-e-sanctions",
                label: "B.2.e. Sanctions",
                className: "b-2-e-sanctions",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/residential-life-policies",
                label: "B.2.f. Residential Life Policies",
                className: "residential-life-policies",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/g-student-health-policies",
                label: "B.2.g. Student Health Policies",
                className: "g-student-health-policies",
              },
              {
                value:
                  "ii-ug-college-policies/ug-policies/res-life-conduct-policies/student-organization-policies",
                label: "B.2.h. Student Organization Policies",
                className: "student-organization-policies",
              },
            ],
          },
        ],
      },
      {
        value: "ii-ug-college-policies/faculty",
        label: "C. Faculty Handbook",
        className: "faculty",
        children: [
          {
            value: "ii-ug-college-policies/faculty/faculty-procedures",
            label: "C.1. Faculty Rules and Procedures",
            className: "faculty-procedures",
          },
          {
            value: "ii-ug-college-policies/faculty/faculty-committees",
            label: "C.2. Faculty Councils and Committees",
            className: "faculty-committees",
          },
          {
            value: "ii-ug-college-policies/faculty/faculty-rules",
            label: "C.3. Rules of Appointment and Tenure for Academic Faculty",
            className: "faculty-rules",
          },
          {
            value: "ii-ug-college-policies/faculty/pe-faculty-rules",
            label: "C.4. Rules of Reappointment for Physical Education Faculty",
            className: "pe-faculty-rules",
          },
          {
            value: "ii-ug-college-policies/faculty/appeals",
            label: "C.5. Appeal Procedures",
            className: "appeals",
          },
          {
            value: "ii-ug-college-policies/faculty/misconduct",
            label: "C.6. Faculty Misconduct",
            className: "misconduct",
          },
          {
            value: "ii-ug-college-policies/faculty/leave-program",
            label: "C.7. Research Leave Program",
            className: "leave-program",
          },
          {
            value: "ii-ug-college-policies/faculty/faculty-development",
            label: "C.8. Faculty Professional Development",
            className: "faculty-development",
          },
          {
            value: "ii-ug-college-policies/faculty/dep-care-policy",
            label: "C.9. Dependent Care Program",
            className: "dep-care-policy",
          },
          {
            value: "ii-ug-college-policies/faculty/research-policies",
            label: "C.10. Research Policies",
            className: "research-policies",
          },
          {
            value: "ii-ug-college-policies/faculty/research-misconduct",
            label: "C.11. Misconduct in Research - Policies and Procedures",
            className: "research-misconduct",
          },
          {
            value: "ii-ug-college-policies/faculty/reprints-subventions",
            label: "C.12. Reprints, Subvention, and Open Access",
            className: "reprints-subventions",
          },
          {
            value: "ii-ug-college-policies/faculty/contract-policy",
            label: "C.13. Grants & Contracts",
            className: "contract-policy",
          },
          {
            value: "ii-ug-college-policies/faculty/outside-employment",
            label: "C.14. Consulting and Outside Employment Policies",
            className: "outside-employment",
          },
          {
            value: "ii-ug-college-policies/faculty/faculty-lecture-payments",
            label: "C.15. Payment for Faculty Lectures Policy",
            className: "faculty-lecture-payments",
          },
          {
            value: "ii-ug-college-policies/faculty/extra-service-pay-policy",
            label: "C.16. Extra Service Pay Policy",
            className: "extra-service-pay-policy",
          },
          {
            value: "ii-ug-college-policies/faculty/faculty-and-athletics",
            label: "C.17. Athletics Information for Faculty",
            className: "faculty-and-athletics",
          },
          {
            value: "ii-ug-college-policies/faculty/special-provisions",
            label:
              "C.18. Special Provisions (associate status and release from contract)",
            className: "special-provisions",
          },
          {
            value: "ii-ug-college-policies/faculty/administrative-appt",
            label: "C.19. Administrative Appointments - Terms/Conditions",
            className: "administrative-appt",
          },
          {
            value: "ii-ug-college-policies/faculty/familial-leaves",
            label: "C.20. Leaves of Absence (nonacademic)",
            className: "familial-leaves",
          },
          {
            value: "ii-ug-college-policies/faculty/disability-pay",
            label: "C.21. Disability",
            className: "disability-pay",
          },
          {
            value: "ii-ug-college-policies/faculty/death-benefit",
            label: "C.22. Death Benefits",
            className: "death-benefit",
          },
          {
            value: "ii-ug-college-policies/faculty/faculty-housing",
            label: "C.23. Housing Programs",
            className: "faculty-housing",
          },
          {
            value: "ii-ug-college-policies/faculty/misc-policies",
            label: "C.24. Miscellaneous Policies",
            className: "misc-policies",
          },
          {
            value: "ii-ug-college-policies/faculty/consensual-relationships-faculty",
            label: "C.25. Policy on Consensual Relationships Between Faculty and Staff Members and Students",
            className: "consensual-relationships-faculty",
          },
          {
            value: "ii-ug-college-policies/faculty/tenure-extension",
            label: "C.26. Tenure Extension",
            className: "tenure-extension",
          },
        ],
      },
      {
        value: "ii-ug-college-policies/employee",
        label: "D. Employee Handbook",
        className: "employee",
        children: [
          {
            value: "ii-ug-college-policies/employee/introduction",
            label: "1. Introduction",
            className: "introduction",
            children: [
              {
                value: "ii-ug-college-policies/employee/introduction/intro",
                label: "1.1 Introduction",
                className: "intro",
              },
              {
                value: "ii-ug-college-policies/employee/introduction/expects",
                label: "1.2 Middlebury College Expects",
                className: "expects",
              },
              {
                value: "ii-ug-college-policies/employee/introduction/offers",
                label: "1.3 Middlebury College Offers",
                className: "offers",
              },
            ],
          },
          {
            value: "ii-ug-college-policies/employee/employment",
            label: "2. Employment",
            className: "employment",
            children: [
              {
                value:
                  "ii-ug-college-policies/employee/employment/2-1-equal-employment-opportunity-policy",
                label: "2.1 Equal Employment Opportunity Policy",
                className: "2-1-equal-employment-opportunity-policy",
              },
              {
                value: "ii-ug-college-policies/employee/employment/ada",
                label: "2.2 Americans with Disabilities Act (ADA)",
                className: "ada",
              },
              {
                value: "ii-ug-college-policies/employee/employment/basic-info",
                label:
                  "2.3 Basic Information about Employment at Middlebury College",
                className: "basic-info",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/2-4-release-of-information-and-employment-confidentiality",
                label:
                  "2.4 Release of Information and Employment Confidentiality",
                className:
                  "2-4-release-of-information-and-employment-confidentiality",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/employment-family",
                label: "2.5 Employment of Family Members",
                className: "employment-family",
              },
              {
                value: "ii-ug-college-policies/employee/employment/orientation",
                label: "2.6 New Employee Orientation",
                className: "orientation",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/starting-work",
                label: "2.7 Starting Work",
                className: "starting-work",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/provisional-period",
                label: "2.8 Provisional Period",
                className: "provisional-period",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/scheduling-hours-operation",
                label: "2.9 Scheduling and Hours of Operation",
                className: "scheduling-hours-operation",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/safety-security",
                label: "2.10 Safety & Security",
                className: "safety-security",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/anti-har-policy",
                label:
                  "2.11 Middlebury College Anti-Harassment/Discrimination Policy",
                className: "anti-har-policy",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/reserved-for-future-use",
                label:
                  "2.12 Reserved for Future Use",
                className: "reserved-for-future-use",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/alcohol-testing-captains",
                label:
                  "2.13 Controlled Substance and Alcohol Testing for Captains and Crew Members",
                className: "alcohol-testing-captains",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/criminal-background-ch",
                label: "2.14 Background Checks",
                className: "criminal-background-ch",
              },
              {
                value: "ii-ug-college-policies/employee/employment/popes",
                label: "2.15 Post-Offer Pre-Employment Screening (POPES)",
                className: "popes",
              },
              {
                value: "ii-ug-college-policies/employee/employment/midd-points",
                label: "2.16 MiddPoints",
                className: "midd-points",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/internal-career",
                label: "2.17 Internal Career Opportunities",
                className: "internal-career",
              },
              {
                value: "ii-ug-college-policies/employee/employment/rehire",
                label: "2.18 Rehire",
                className: "rehire",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/staff-computer-use",
                label: "2.19 Staff E-mail and Computer Use Policy",
                className: "staff-computer-use",
              },
              {
                value:
                  "ii-ug-college-policies/employee/employment/consensual-relationships-employee-student",
                label: "2.20 Policy on Consensual Relationships Between Employees (Faculty and Staff) and Students",
                className: "consensual-relationships-employee-student",
              }
            ],
          },
          {
            value: "ii-ug-college-policies/employee/benefits",
            label: "3. Employee Benefits",
            className: "benefits",
            children: [
              {
                value: "ii-ug-college-policies/employee/benefits/general-info",
                label: "3.1 General Information",
                className: "general-info",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/benefit-changes",
                label: "3.2 Benefit Changes",
                className: "benefit-changes",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/health-welfare",
                label: "3.3 Health and Welfare Benefit Plan",
                className: "health-welfare",
              },
              {
                value: "ii-ug-college-policies/employee/benefits/efap",
                label: "3.4 Employee & Family Assistance Plan (EFAP)",
                className: "efap",
              },
              {
                value: "ii-ug-college-policies/employee/benefits/retirement",
                label: "3.5 Retirement Plan",
                className: "retirement",
              },
              {
                value: "ii-ug-college-policies/employee/benefits/phased-ret",
                label: "3.6 Phased Retirement",
                className: "phased-ret",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/educational-assistance",
                label: "3.7 Educational Assistance",
                className: "educational-assistance",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/sick-leave-conversion",
                label: "3.8 Sick Leave Conversion",
                className: "sick-leave-conversion",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/survivor-benefits",
                label: "3.9 Survivor Benefits",
                className: "survivor-benefits",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/midd-card-priveleges",
                label: "3.10 Midd Card Privileges",
                className: "midd-card-priveleges",
              },
              {
                value: "ii-ug-college-policies/employee/benefits/discounts",
                label: "3.11 Golf & Ski Discounts",
                className: "discounts",
              },
              {
                value:
                  "ii-ug-college-policies/employee/benefits/nursing-mothers",
                label: "3.12 Nursing Mothers",
                className: "nursing-mothers",
              },
            ],
          },
          {
            value: "ii-ug-college-policies/employee/time-away",
            label: "4. Time Away from Work",
            className: "time-away",
            children: [
              {
                value:
                  "ii-ug-college-policies/employee/time-away/reporting-absences",
                label: "4.1 Reporting Absences",
                className: "reporting-absences",
              },
              {
                value: "ii-ug-college-policies/employee/time-away/cto",
                label: "4.2 Combined Time Off",
                className: "cto",
              },
              {
                value: "ii-ug-college-policies/employee/time-away/slr",
                label: "4.3 Sick Leave Reserve",
                className: "slr",
              },
              {
                value: "ii-ug-college-policies/employee/time-away/holidays",
                label: "4.4 Holidays",
                className: "holidays",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/staff-parental-leave",
                label: "4.5 Staff Parental Leave Policy",
                className: "staff-parental-leave",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/family-medical-leave",
                label: "4.6 Family & Medical Leave",
                className: "family-medical-leave",
              },
              {
                value: "ii-ug-college-policies/employee/time-away/jury-duty",
                label: "4.7 Jury Duty",
                className: "jury-duty",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/military-reserve",
                label: "4.8 Military Reserve",
                className: "military-reserve",
              },
              {
                value: "ii-ug-college-policies/employee/time-away/bereavement",
                label: "4.9 Bereavement",
                className: "bereavement",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/personal-leave",
                label: "4.10 Personal Leave of Absence",
                className: "personal-leave",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/weather-emergencies",
                label: "4.11 Weather Emergencies",
                className: "weather-emergencies",
              },
              {
                value: "ii-ug-college-policies/employee/time-away/release-time",
                label: "4.12 Release Time",
                className: "release-time",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/4-13-vermont-earned-sick-time-act",
                label: "4.13 Vermont Earned Sick Time Act",
                className: "4-13-vermont-earned-sick-time-act",
              },
              {
                value:
                  "ii-ug-college-policies/employee/time-away/4-14-vermont-earned-sick-time",
                label: "4.14 Vermont Earned Sick Time",
                className: "4-14-vermont-earned-sick-time",
              },
            ],
          },
          {
            value: "ii-ug-college-policies/employee/payroll",
            label: "5. Payroll",
            className: "payroll",
            children: [
              {
                value: "ii-ug-college-policies/employee/payroll/direct-deposit",
                label: "5.1 Direct Deposit",
                className: "direct-deposit",
              },
              {
                value: "ii-ug-college-policies/employee/payroll/deductions",
                label: "5.2 Deductions",
                className: "deductions",
              },
              {
                value: "ii-ug-college-policies/employee/payroll/advances",
                label: "5.3 Advances",
                className: "advances",
              },
              {
                value: "ii-ug-college-policies/employee/payroll/payroll-issues",
                label: "5.4 Reporting Time and Payroll Issues",
                className: "payroll-issues",
              },
            ],
          },
          {
            value: "ii-ug-college-policies/employee/wage-salary",
            label: "6. Staff Compensation",
            className: "wage-salary",
            children: [
              {
                value:
                  "ii-ug-college-policies/employee/wage-salary/staff-compensation-program",
                label: "6.1 Staff Compensation Program",
                className: "staff-compensation-program",
              },
              {
                value:
                  "ii-ug-college-policies/employee/wage-salary/job-descriptions",
                label: "6.2 Job Descriptions",
                className: "job-descriptions",
              },
              {
                value: "ii-ug-college-policies/employee/wage-salary/overtime",
                label: "6.3 Eligibility for Overtime and FLSA Compliance",
                className: "overtime",
              },
              {
                value:
                  "ii-ug-college-policies/employee/wage-salary/shift-differentials",
                label: "6.4 Shift Differentials",
                className: "shift-differentials",
              },
              {
                value:
                  "ii-ug-college-policies/employee/wage-salary/compensation-issue-resolution-process",
                label: "6.5 Compensation Issue Resolution Process",
                className: "compensation-issue-resolution-process",
              },
              {
                value:
                  "ii-ug-college-policies/employee/wage-salary/travel-time",
                label: "6.6 Travel Time",
                className: "travel-time",
              },
            ],
          },
          {
            value: "ii-ug-college-policies/employee/evaluating",
            label: "7. Evaluating Job Performance",
            className: "evaluating",
          },
          {
            value: "ii-ug-college-policies/employee/processes-development",
            label: "8. Employee Relations",
            className: "processes-development",
            children: [
              {
                value:
                  "ii-ug-college-policies/employee/processes-development/problem-solving",
                label: "8.1 Problem Solving",
                className: "problem-solving",
              },
              {
                value:
                  "ii-ug-college-policies/employee/processes-development/progressive-discipline",
                label: "8.2 Progressive Discipline",
                className: "progressive-discipline",
              },
              {
                value:
                  "ii-ug-college-policies/employee/processes-development/staff-dev-funds",
                label: "8.3 Staff Development Funds",
                className: "staff-dev-funds",
              },
            ],
          },
          {
            value: "ii-ug-college-policies/employee/leaving-midd",
            label: "9. Leaving Middlebury College",
            className: "leaving-midd",
            children: [
              {
                value:
                  "ii-ug-college-policies/employee/leaving-midd/leaving-middlebury-college",
                label: "9.1 Leaving Middlebury College",
                className: "leaving-middlebury-college",
              },
              {
                value:
                  "ii-ug-college-policies/employee/leaving-midd/resignation",
                label: "9.2 Voluntary Termination of Employment: Resignation",
                className: "resignation",
              },
              {
                value: "ii-ug-college-policies/employee/leaving-midd/discharge",
                label: "9.3 Discharge",
                className: "discharge",
              },
              {
                value:
                  "ii-ug-college-policies/employee/leaving-midd/retirement",
                label: "9.4 Retirement",
                className: "retirement",
              },
              {
                value: "ii-ug-college-policies/employee/leaving-midd/rif",
                label: "9.5 Reduction in Force",
                className: "rif",
              },
            ],
          },
        ],
      },
    ],
  }
]